import { config } from "../../config"

export const contributors = {
  readAll: ({ randomized, limit }) => {
    const url = new URL(`${config.apiUrl}/contributors`)
    if (randomized) url.searchParams.set("randomized", randomized)
    if (limit) url.searchParams.set("limit", limit)

    const opt = {
      method: "GET",
    }

    return { url: url.toString(), opt }
  },
}
